import { useCallback, useMemo } from 'react'
import { useGetSettingsQuery } from '../queries/useGetSettingsQuery'

/** Accents that keep white text readable, in the order audiences take them. */
const AUDIENCE_COLORS = ['blue', 'purple', 'green', 'orange', 'magenta', 'teal', 'lavender', 'salmon', 'red', 'pink']

const hashOf = (text: string) => Array.from(text).reduce((sum, char) => sum + char.charCodeAt(0), 0)

/** By position in the settings list, so a short list never repeats; by name once removed from it. */
export const useAudienceColor = () => {
    const { data } = useGetSettingsQuery()
    const audiences = useMemo(() => data?.vmAudiences ?? [], [data?.vmAudiences])

    return useCallback(
        (audience: string) => {
            const position = audiences.indexOf(audience)
            const slot = position === -1 ? hashOf(audience) : position

            return `figma.accentColors.${AUDIENCE_COLORS[slot % AUDIENCE_COLORS.length]}`
        },
        [audiences]
    )
}

export default useAudienceColor
